// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase/compat/app';

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import 'firebase/compat/analytics';

// Add the Firebase products that you want to use
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/functions';

const developmentConfig = {
  apiKey: 'AIzaSyCGqNPUnvvO9sGCfYeC3IdeAw_jMUpJ5NQ',
  authDomain: 'brunoni-allmarine.firebaseapp.com',
  databaseURL: 'https://brunoni-allmarine.firebaseio.com',
  projectId: 'brunoni-allmarine',
  storageBucket: 'brunoni-allmarine.appspot.com',
  messagingSenderId: '954272298910',
  appId: '1:954272298910:web:e52f968551a80bbadbc88f',
};

const productionConfig = {
  brunoni: {
    apiKey: 'AIzaSyBuI3STGixq5uWBcCzrUuMGfbifkDOZYN0',
    authDomain: 'brunoni.firebaseapp.com',
    databaseURL: 'https://brunoni.firebaseio.com',
    projectId: 'brunoni',
    storageBucket: 'brunoni.appspot.com',
    messagingSenderId: '154343276895',
    appId: '1:154343276895:web:a30fe5aced02b0373af6ea',
  },
  allmarine: {
    apiKey: 'AIzaSyBfF4OAXLNZsNgER4bKnZhABWIZron9T4o',
    authDomain: 'allmarine.firebaseapp.com',
    databaseURL: 'https://allmarine.firebaseio.com',
    projectId: 'allmarine',
    storageBucket: 'allmarine.appspot.com',
    messagingSenderId: '707393375364',
    appId: '1:707393375364:web:283aa80ae0e376749f86d1',
  },
};

const firebaseConfig =
  import.meta.env.MODE === 'development' || import.meta.env.MODE === 'staging'
    ? developmentConfig // TODO this means that stage.brunoni.ch will use brunoni-allmarine DB. Good for now, revisit later :)
    : import.meta.env.MODE === 'production'
      ? productionConfig[import.meta.env.VITE_BRAND as 'brunoni' | 'allmarine']
      : import.meta.env.VITE_REACT_APP_API_URL === 'https://stage-dot-brunoni.appspot.com'
        ? productionConfig.brunoni
        : import.meta.env.VITE_REACT_APP_API_URL === 'https://stage-dot-allmarine.appspot.com'
          ? productionConfig.allmarine
          : developmentConfig;

firebase.initializeApp(firebaseConfig);

firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED,
});

export default firebase;
